<template>
    <input
        type="date"
        ref="input"
        v-bind:value="updateInput(value)"
        v-on:input="updateValue($event.target.value)"
        v-on:change="changeValue($event.target.value)"
        :min="min"
        :max="max"
    >
</template>

<script>
    import moment from "moment";

    export default {
        name: "input-date",
        props: ['value', 'min', 'max'],
        methods: {
            updateValue: function(inputValue) {
                if (inputValue === "") {
                    this.$emit("input", null);
                    return
                }
                this.$emit("input", moment.utc(inputValue).toISOString());
            },
            updateInput: function (value) {
                if (!value) {
                    return "";
                }
                return moment.utc(value).format("YYYY-MM-DD");
            },
            changeValue: function(inputValue) {
                if (inputValue === "") {
                    this.$emit("change", null);
                    return
                }
                this.$emit("change", moment.utc(inputValue).toISOString());
            }
        }
    }
</script>